var OPS = require('./index.json')

var map = {}
for (var op in OPS) {
  var code = OPS[op]
  map[code] = op
}

module.exports = map



//////////////////
// WEBPACK FOOTER
// ./~/bitcoin-ops/map.js
// module id = gWXo
// module chunks = 0